import { cn } from "@/lib/utils"

import GreenCheck from "@/assets/img/profile/plan/green_check.svg?react"

import { useSheetDismiss } from "../hooks/use-sheet-dismiss"

interface PlanCanceledModalProps {
  /** Formatted period-end date, or null when it can't be derived. */
  activeUntilLabel: string | null
  onContinue: () => void
}

/** Success sheet shown after a subscription is canceled. */
export function PlanCanceledModal({ activeUntilLabel, onContinue }: PlanCanceledModalProps) {
  const { backdropClass, panelClass, dismiss } = useSheetDismiss()

  const activeUntil = activeUntilLabel
    ? `Your plan is active until ${activeUntilLabel}.`
    : "Your plan stays active until the end of your current billing period."

  return (
    <div
      className={cn(
        "fixed inset-0 z-[1100] mx-auto flex min-h-[100dvh] w-full max-w-app flex-col justify-end bg-dark-base/80 backdrop-blur-[10px]",
        backdropClass,
      )}
    >
      <div
        className={cn(
          "flex flex-col items-center gap-4 rounded-t-3xl bg-dark-surface px-4 pb-4 pt-6",
          panelClass,
        )}
      >
        <div className="flex size-24 items-center justify-center rounded-full bg-green/10 text-green [&_svg]:size-10">
          <GreenCheck />
        </div>

        <div className="flex w-full flex-col gap-2 text-center">
          <h2 className="font-display text-2xl font-medium text-purple-light">
            Your subscription was canceled
          </h2>
          <p className="font-body text-base text-purple-light/70">
            {activeUntil} Thanks for using our product!
          </p>
        </div>

        <button
          type="button"
          onClick={() => dismiss(onContinue)}
          className="flex h-14 w-full items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white"
        >
          Continue
        </button>
      </div>
    </div>
  )
}
